import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            分类导航
          </h2>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === "all" ? "/category/all" : `/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`ri-${getCategoryIcon(cat.slug)} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  const map: Record<string, string> = {
    all: "grid-line",
    romance: "heart-line",
    fantasy: "magic-line",
    action: "sword-line",
    drama: "theatre-line",
    comedy: "emotion-happy-line",
    suspense: "search-eye-line",
    bl: "men-line",
    gl: "women-line",
  };
  return map[slug] || "book-line";
}